import { useCallback, useState, useEffect } from "react";
import { getRequest } from "../config";

const useTempAdHistoryData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getRequest(`/ads/temp-history`);
            setData(response?.body || null);
        } catch (error) {
            setData(null);
            console.error('Error fetching temp ads history:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, []);

    return { data, loading };
};

export default useTempAdHistoryData;
